export default __webpack_public_path__ + "static/media/ic-plus.2a6a4ffd.svg";